"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paramsToObj = paramsToObj;
exports["default"] = void 0;

function paramsToObj() {
  var paramsString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return paramsString.replace(/(^\?)/, '').split('&').reduce(function (acc, param) {
    var params = param.split('=');
    if (params[0] && params[1]) acc[params[0]] = params[1];
    return acc;
  }, {});
}

var _default = paramsToObj;
exports["default"] = _default;